import { Audience, AudiencePreview } from "./types";

interface AudienceCardProps {
  audiences: Audience[];
  selectedAudienceId: number | null;
  preview: AudiencePreview | null;
  audienceLoading: boolean;
  loading: boolean;
  error: string | null;
  onAudienceChange: (value: number | null) => void;
}

export default function AudienceCard({
  audiences,
  selectedAudienceId,
  preview,
  audienceLoading,
  loading,
  error,
  onAudienceChange,
}: AudienceCardProps) {
  return (
    <div className="card">
      <div className="card-title">Contact List</div>

      <div className="form-group">
        <select
          className="form-input"
          value={selectedAudienceId ?? ""}
          disabled={audienceLoading}
          onChange={(event) =>
            onAudienceChange(
              event.target.value ? Number(event.target.value) : null,
            )
          }
        >
          <option value="">
            {audienceLoading
              ? "Loading Contact Lists..."
              : "Select Contact List"}
          </option>
          {audiences.map((audience) => (
            <option key={audience.audienceId} value={audience.audienceId}>
              {audience.name}
            </option>
          ))}
        </select>
      </div>

      {error && <div className="form-error">{error}</div>}

      {loading && (
        <div className="summary-name">Loading audience summary...</div>
      )}

      {!loading && preview && (
        <div className="summary-name">
          Static members: <strong>{preview.staticMembers}</strong> | Rule
          members: <strong>{preview.ruleMembers}</strong> | Total members:{" "}
          <strong>{preview.total}</strong>
        </div>
      )}
    </div>
  );
}
